import { render, staticRenderFns } from "./CollaborateursItem.vue?vue&type=template&id=00607bd2&"
import script from "./CollaborateursItem.vue?vue&type=script&lang=js&"
export * from "./CollaborateursItem.vue?vue&type=script&lang=js&"
import style0 from "./CollaborateursItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports